var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddToSpace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6179_87882",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FF0000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6179_87882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 19.5C17.6944 19.5 21.5 15.6944 21.5 11C21.5 6.30558 17.6944 2.5 13 2.5C8.30558 2.5 4.5 6.30558 4.5 11C4.5 11.9625 4.65996 12.8875 4.95475 13.7501C5.30886 13.3545 5.74574 13.0344 6.23819 12.8172C6.08284 12.2377 6 11.6285 6 11C6 7.13401 9.13401 4 13 4C16.866 4 20 7.13401 20 11C20 14.866 16.866 18 13 18C12.3715 18 11.7623 17.9172 11.1828 17.7618C10.9656 18.2543 10.6455 18.6911 10.2499 19.0453C11.1125 19.34 12.0375 19.5 13 19.5Z",
    fill: "#090C10"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 16.25C13 19.1495 10.6495 21.5 7.75 21.5C4.85051 21.5 2.5 19.1495 2.5 16.25C2.5 13.3505 4.85051 11 7.75 11C10.6495 11 13 13.3505 13 16.25ZM7.75 20C9.82107 20 11.5 18.3211 11.5 16.25C11.5 14.1789 9.82107 12.5 7.75 12.5C5.67893 12.5 4 14.1789 4 16.25C4 18.3211 5.67893 20 7.75 20Z",
    fill: "#090C10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6 19.2H7.1V17.1H5V15.6H7.1V13.5H8.6V15.6H10.7V17.1H8.6V19.2Z",
    fill: "#090C10"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToSpace);
export default __webpack_public_path__ + "static/media/add-to-space.77bd1831e6cd5e40dbe581a2f47cfee8.svg";
export { ForwardRef as ReactComponent };